module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_7005.b7fd3aa7.png";